module.exports = __webpack_public_path__ + "img/background-invite-new-user.4651810f.jpg";